import React from "react";
import Button from "../../shared/button";
import Chatbot from "../chatbot/chatbot";
import { useTranslation } from "react-i18next";

const Blogbanner = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="about-banner-main flex justify-center items-center relative back-banner max-xxxl:min-h-screen min-h-[calc(100vh_-_150px)] w-100 bg-white rounded-t-none rounded-bl-[38px] rounded-br-[38px]">
        <div className="content  z-[2] pt-[100px] max-sm:pt-[0px]   max-xxxl:max-w-[90%] max-w-[80%]   m-auto flex flex-col justify-center items-center">
          <div className="flex flex-col justify-center items-center">
            <h1 className="text-center text-white font-sora tracking-[-2px] leading-[90px]">
              {t("blog.title")}
            </h1>
            <h1 className="text-center gradient-text font-sora tracking-[-2px] leading-[90px] max-sm:leading-[65px] max-w-[1320px]">
              {t("blog.subtitle")}
            </h1>
            <Button
              text={t("blog.button")}
              className="button btn-gradient-border mt-[20px] !font-semibold"
              height={61}
              width={240}
            />
          </div>
          {/* <div className="search-bar mt-[75px] max-exl:mt-[65px] max-w-[1053px] w-full rounded-[38px] bg-[#FFFFFF] p-[9px] pl-[43px] flex gap-[10px] justify-between h-[77px]">
            <input
              type="text"
              placeholder={t("blog.inputPlaceholder")}
              className="bg-transparent w-full"
            />
            <Button
              text={t("blog.subscribe")}
              className="button btn-secondary"
              height={60}
              width={198}
            ></Button>
          </div> */}
        </div>
      </div>
      <Chatbot />
    </>
  );
};

export default Blogbanner;
